/* eslint-disable no-unused-expressions */
import React, { useState } from 'react';

import {
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  IconButton,
  LinearProgress,
  TextField,
  Typography,
  Paper,
  Dialog
} from '@material-ui/core';

import axios from 'axios';
import Draggable from 'react-draggable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Button from 'components/Button/button';
import CommonAlert from 'components/CommonAlert/CommonAlert';
import { LocalizationPlainText } from 'components/Localization';
import CloseIconNavy from 'images/icons/signals/closesAndCancels/closeTransparent.svg';
import * as UserActions from 'store/actions/user';
import Environment from 'utils/environments';

function PaperComponent(props) {
  return (
    <Draggable handle="#flagDialog" cancel='[class*="MuiDialogContent-root"]'>
      <Paper {...props} />
    </Draggable>
  );
}

function FlagDialog({ userInfo, open, flag, onClose, onSuccess }) {
  const environments = Environment(process.env.REACT_APP_ENV);
  const userLocal = JSON.parse(localStorage.getItem('companies'));
  const profile = userInfo?.profile[0][0]?.name;
  const isLabelAdmin = profile === 'admin_label';
  const currentUserId = isLabelAdmin
    ? userLocal?.labelId
    : userInfo.companiesActive.id;

  const [formData, setFormData] = useState({
    description: flag?.description || ''
  });
  const [loading, setLoading] = useState(false);
  const [invalidFields, setInvalidFields] = useState({
    description: false
  });
  const [message, setMessage] = useState({
    description: '',
    status: ''
  });

  const config = {
    headers: {
      User: `${userLocal?.user}`
    }
  };

  const isDisabledSubmit = () => {
    if (!flag) return false;

    return Object.keys(formData).every((key) => formData[key] === flag[key]);
  };

  const validFields = (body) => {
    const isAllValid = {
      description: !body.description
    };

    setInvalidFields(isAllValid);

    return !isAllValid.description;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async () => {
    if (!validFields(formData)) return;

    setLoading(true);

    if (flag) {
      axios
        .put(
          `${environments.catalog}/flags/${flag?.id}`,
          {
            description: formData?.description,
            user: userInfo.user
          },
          config
        )
        .then(() => {
          setLoading(false);
          onSuccess();
          setMessage({
            description: 'Marca Atualizada com sucesso',
            status: 'success'
          });
          onClose &&
            setTimeout(() => {
              onClose();
            }, 1000);
        })
        .catch((error) => {
          setLoading(false);
          setMessage({
            description:  error?.response?.data?.message,
            status: 'error'
          });
        });
    } else {
      axios
        .post(
          `${environments.catalog}/flags`,
          {
            description: formData?.description,
            restaurantId: currentUserId,
            user: userInfo.user
          },
          config
        )
        .then((res) => {
          setLoading(false);
          onSuccess();
          setMessage({
            description: 'Marca criada com sucesso',
            status: 'success'
          });
          onClose &&
            setTimeout(() => {
              onClose();
            }, 1000);
        })
        .catch((error) => {
          setMessage({
            description:  error?.response?.data?.message,
            status: 'error'
          });
          setLoading(false);
        });
    }
  };

  return (
    <Dialog
      className="defaultModal dialog40"
      open={open}
      onClose={onClose}
      aria-labelledby="flagDialog"
      transitionDuration={0}
      PaperComponent={PaperComponent}
    >
      <DialogTitle className="modalHeader lightBlue" id="flagDialog">
        <Typography>{flag ? 'Editar Marca' : 'Nova Marca'}</Typography>

        <IconButton
          id="closeFlagDialogInput"
          edge="start"
          color="inherit"
          onClick={onClose}
          aria-label="close"
        >
          <img style={{ width: '16px' }} src={CloseIconNavy} alt="CloseIcon" />
        </IconButton>
      </DialogTitle>

      {loading ? <LinearProgress /> : null}

      <DialogContent className="modalContent pt26">
        <Grid className="m0" container xs={12} sm={12} spacing={4}>
          <Grid item xs={12} sm={12} className="pl0 pr0">
            <TextField
              key="descriptionFlagDialogInput"
              id="descriptionFlagDialogInput"
              name="description"
              size="small"
              label={LocalizationPlainText('description', 'translations')}
              variant="outlined"
              fullWidth
              required
              value={formData?.description}
              onChange={handleChange}
              className={`textFieldSmall ${
                invalidFields?.description && 'labelError'
              }`}
              placeholder={LocalizationPlainText('TypeHere', 'translations')}
              tabIndex={0}
            />
          </Grid>
        </Grid>

        <DialogActions className="dialogActions p0">
          <Button
            id="cancelFlagDialogButton"
            label="Voltar"
            className="defaultButton backButton mr20"
            onClick={onClose}
          />

          <Button
            id="submitFlagDialogButton"
            label="Salvar"
            className={`defaultButton submitButton ${
              (isDisabledSubmit() || loading) && 'disabledButton'
            }`}
            onClick={handleSubmit}
            disabled={isDisabledSubmit() || loading}
          />
        </DialogActions>
      </DialogContent>

      <CommonAlert
        open={!!message.description}
        severity={message.status}
        onClose={() => setMessage({ description: '', status: '' })}
        messagePersonal={message.description}
        autoHideDuration={2000}
      />
    </Dialog>
  );
}

const mapStateToProps = (state) => ({
  userInfo: state.user
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(UserActions, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(FlagDialog);
